function schemeToColorValue(scheme) {
  switch (scheme) {
    case 'dark':
      return 'var(--gray)';
    case 'pale':
      return 'var(--pale-gray)';
    case 'bright':
    default:
      return 'var(--white)';
  }
}

function initAdjacentSchemes() {
  const sections = Array.from(document.querySelectorAll('[data-scheme]'));

  sections.forEach((section, index) => {
    const prevSection = sections[index - 1];
    const nextSection = sections[index + 1];

    const currentScheme = section.dataset.scheme || 'bright';
    const prevScheme = prevSection?.dataset.scheme || 'bright';
    const nextScheme = nextSection?.dataset.scheme || 'bright';

    section.dataset.prevScheme = prevScheme;
    section.dataset.nextScheme = nextScheme;

    section.style.setProperty('--divider-current-color', schemeToColorValue(currentScheme));
    section.style.setProperty('--divider-prev-color', schemeToColorValue(prevScheme));
    section.style.setProperty('--divider-next-color', schemeToColorValue(nextScheme));
  });
}

function getHeaderOffset() {
  const selectors = [
    '.shopify-section--header',
    '.header',
    '.header-wrapper',
    '#shopify-section-header'
  ];

  for (const selector of selectors) {
    const el = document.querySelector(selector);
    if (el) {
      return Math.ceil(el.getBoundingClientRect().height);
    }
  }

  return 0;
}

function scrollToHash(hash, updateUrl = true) {
  if (!hash || hash === '#') return;

  const target = document.querySelector(hash);
  if (!target) return;

  const headerOffset = getHeaderOffset();
  const extraOffset = 2;
  const targetTop = window.scrollY + target.getBoundingClientRect().top - headerOffset - extraOffset;

  window.scrollTo({
    top: Math.max(0, targetTop),
    behavior: 'smooth'
  });

  if (updateUrl) {
    history.pushState(null, '', hash);
  }
}

function isSamePageHashLink(link) {
  if (!link || !link.hash) return false;
  if (link.origin !== window.location.origin) return false;
  if (link.pathname !== window.location.pathname) return false;
  return true;
}

function initHashScrollLinks() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    if (!isSamePageHashLink(link)) return;
    if (!link.hash || link.hash === '#') return;

    const target = document.querySelector(link.hash);
    if (!target) return;

    event.preventDefault();
    scrollToHash(link.hash, true);
  });

  if (window.location.hash) {
    window.setTimeout(() => {
      scrollToHash(window.location.hash, false);
    }, 50);
  }
}

function initSectionSchemes() {
  initAdjacentSchemes();
  initHashScrollLinks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSectionSchemes);
} else {
  initSectionSchemes();
}
